export const setIsGiftcardDisabled = value => ({
    type: 'SET_IS_GIFTCARD_DISABLED',
    value
});
